/**
 * The method below uses the auth integration to return an access token
 * which will be used when making calls to the API.
 */
import { fetchAuthSession, signOut } from "aws-amplify/auth";
import { usePiniaStore } from "@/stores/store";
import { redirectToRoute, routeIsLogin } from "@/router";
import { showAlert } from "@/methods/errorHandling";
import { AuthRouteNames } from "@/constants/routes";

export const getToken = async () => {
    const pStore = usePiniaStore();

    try {
        const session = await fetchAuthSession();
        const token = session.tokens?.accessToken;
        if (!token) {
            //** Sign out user if we cannot get a token */
            pStore.setIsAuthenticated(false);
            await signOut({ global: true });
            if (!routeIsLogin()) {
                showAlert("alerts.expiredSession");
                redirectToRoute({ name: AuthRouteNames.LOGIN });
            }
            return null;
        }
        return token;
    } catch (error) {
        //** Sign out user if we cannot get a token */
        pStore.setIsAuthenticated(false);
        await signOut({ global: true });
        if (!routeIsLogin()) {
            showAlert("alerts.expiredSession");
            redirectToRoute({ name: AuthRouteNames.LOGIN });
        }
        return null;
    }
};
